import {Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'app-paper-stage-selector',
    templateUrl: './paper-stage-selector.component.html',
    styleUrls: ['./paper-stage-selector.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => PaperStageSelectorComponent)
        }
    ]
})
export class PaperStageSelectorComponent implements ControlValueAccessor {

    @Output() selected = new EventEmitter();
    @Input() tree;
    @Input() value;

    public propagateChange = (_) => {
    };

    constructor() {
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
    }

    writeValue(obj: any): void {
        if (obj) {
            this.value = obj;
        }
    }

    changed() {
        this.propagateChange(this.value);
        this.selected.emit(this.value);
    }

}
